module.exports = __webpack_public_path__ + "zl1-b00dbbc8.png";